import { Injectable } from '@angular/core';
import { ApiService } from '@app/shared/services/api/api.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class NotificationUserService extends ApiService {
  notificationUserUrl = `energyguard/notificationusers/`;

  constructor(public http: HttpClient) {
    super(http);
  }

  getNotificationUsersByBuildingId(municipalityKey: string, buildingId: string) {
    return this.http.get(this.endpoint(`socrates/meters/api/municipalities/${municipalityKey}/buildings/${buildingId}/notificationUsers`));
  }

  createNotificationUsersForBuildingId(municipalityKey: string, buildingId: string, users: any) {
    return this.http.post(this.endpoint(`socrates/meters/api/municipalities/${municipalityKey}/buildings/${buildingId}/notificationUsers`), users);
  }

  deleteNotificationUserByUserId(municipalityKey: string, buildingId: string, notificationUserGuid: string) {
    return this.http.delete(
      this.endpoint(`socrates/meters/api/municipalities/${municipalityKey}/buildings/${buildingId}/notificationUsers/${notificationUserGuid}`),
    );
  }
}
